import { render, staticRenderFns } from "./SystemChangeLogs.vue?vue&type=template&id=cdc9fdd4&scoped=true&"
import script from "./SystemChangeLogs.vue?vue&type=script&lang=js&"
export * from "./SystemChangeLogs.vue?vue&type=script&lang=js&"
import style0 from "./SystemChangeLogs.vue?vue&type=style&index=0&id=cdc9fdd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdc9fdd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/monbi/bbx/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cdc9fdd4')) {
      api.createRecord('cdc9fdd4', component.options)
    } else {
      api.reload('cdc9fdd4', component.options)
    }
    module.hot.accept("./SystemChangeLogs.vue?vue&type=template&id=cdc9fdd4&scoped=true&", function () {
      api.rerender('cdc9fdd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/SystemChangeLogs.vue"
export default component.exports